import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// components
import { Flex, Box } from '@rebass/grid';
import { P } from 'app/ui_components/tags';
import IconWithDonut from 'app/ui_components/IconWithDonut';

// helpers
import { isMobile } from 'app/helpers/utils';

// =======================
// == styled components ==
// =======================
const Container = styled(Box).attrs({
  p: [30, 35],
})`
  ${isMobile && 'text-align:center;'};
  &:not(:last-of-type) {
    border-bottom: 1px solid #eee;
  }
`;

const DIMENSION = 22;

const Status = styled.span.attrs({
  className: 'fas',
})`
  min-height: ${DIMENSION}px;
  min-width: ${DIMENSION}px;
  max-height: ${DIMENSION}px;
  max-width: ${DIMENSION}px;
  background: ${({ positive }) => (positive ? '#73B567' : '#D35047')};
  color: white;
  display: inline-flex;
  border-radius: 100%;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  margin-right:1rem;
  &:after{
    content: '\f00${({ positive }) => (positive ? 'c' : 'd')}';
  }
`;

const Label = styled.span`
  ${isMobile && 'text-align:left;'};
`;

const ReportItem = ({ item, data }) => {
  let percentage = data.filter(item => item.passed).length / data.length * 100;
  percentage = percentage === 0 ? 10 : percentage;
  return (
    <Container key={item} id={item} className="sectionContainer">
      <Flex flexDirection={isMobile ? 'column' : 'row'}>
        <Box mr={20} width={[1 / 1, 1 / 1, 1 / 5]}>
          <IconWithDonut graphic={item} percentage={percentage} />
          <P size={15} weight={500}>
            {item}
          </P>
        </Box>
        <Box width={[1 / 1, 1 / 1, 4 / 5]}>
          <Flex flexDirection="column">
            {data.map(({ id, name, message, passed }, index) => {
              const isLast = index === data.length - 1;
              return (
                <Box id={id} key={id}>
                  <P
                    size={14}
                    weight={500}
                    color="#363740"
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    textAlign={isMobile ? 'center' : 'left'}
                  >
                    <Status positive={passed} />
                    <Label>{name}</Label>
                  </P>
                  <P
                    size={14}
                    color="#4E4F57"
                    textAlign="justify"
                    style={{
                      marginTop: '8px',
                      marginBottom: isLast ? 0 : '24px',
                    }}
                  >
                    {message}
                  </P>
                </Box>
              );
            })}
          </Flex>
        </Box>
      </Flex>
    </Container>
  );
};

ReportItem.defaultProps = {};

ReportItem.propTypes = {
  item: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};

export default ReportItem;
